import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PrestamosService } from '../../../services/prestamos.service';
import { ConfiguracionesService } from '../../../services/configuraciones.service';
declare var window: any;
@Component({
  selector: 'app-detalle',
  templateUrl: './detalle.component.html',
  styleUrls: ['./detalle.component.css']
})
export class DetalleComponent implements OnInit {
  @Input() recibo;
  numeroALetra = (function() {

    function Unidades(num) {

        switch (num) {
            case 1: return 'un';
            case 2: return 'Dos';
            case 3: return 'Tres';
            case 4: return 'Cuatro';
            case 5: return 'Cinco';
            case 6: return 'Seis';
            case 7: return 'Siete';
            case 8: return 'Ocho';
            case 9: return 'Nueve';
        }

        return '';
    }// Unidades()

    function Decenas(num) {

        const decena = Math.floor(num / 10);
        const unidad = num - (decena * 10);

        switch (decena) {
            case 1:
                switch (unidad) {
                    case 0: return 'Diez';
                    case 1: return 'Once';
                    case 2: return 'Doce';
                    case 3: return 'Trece';
                    case 4: return 'Catorce';
                    case 5: return 'Quince';
                    default: return 'Dieci' + Unidades(unidad);
                }
            case 2:
                switch (unidad) {
                    case 0: return 'Veinte';
                    default: return 'Veinti' + Unidades(unidad);
                }
            case 3: return DecenasY('Treinta', unidad);
            case 4: return DecenasY('Cuarenta', unidad);
            case 5: return DecenasY('Cincuenta', unidad);
            case 6: return DecenasY('Sesenta', unidad);
            case 7: return DecenasY('Setenta', unidad);
            case 8: return DecenasY('Ochenta', unidad);
            case 9: return DecenasY('Noventa', unidad);
            case 0: return Unidades(unidad);
        }
    }// Unidades()

    function DecenasY(strSin, numUnidades) {
        if (numUnidades > 0) {
            return strSin + ' y ' + Unidades(numUnidades);
        }

        return strSin;
    }// DecenasY()

    function Centenas(num) {
        const centenas = Math.floor(num / 100);
        const decenas = num - (centenas * 100);

        switch (centenas) {
            case 1:
                if (decenas > 0) {
                    return 'Ciento ' + Decenas(decenas);
                }
                return 'Cien';
            case 2: return 'Doscientos ' + Decenas(decenas);
            case 3: return 'Trescientos ' + Decenas(decenas);
            case 4: return 'Cuatrocientos ' + Decenas(decenas);
            case 5: return 'Quinientos ' + Decenas(decenas);
            case 6: return 'Seiscientos ' + Decenas(decenas);
            case 7: return 'Setecientos ' + Decenas(decenas);
            case 8: return 'Ochocientos ' + Decenas(decenas);
            case 9: return 'Novecientos ' + Decenas(decenas);
        }

        return Decenas(decenas);
    }// Centenas()

    function Seccion(num, divisor, strSingular, strPlural) {
        const cientos = Math.floor(num / divisor);
        const resto = num - (cientos * divisor);

        let letras = '';

        if (cientos > 0) {
        if (cientos > 1) {
                letras = Centenas(cientos) + ' ' + strPlural;
            } else {
                letras = strSingular;
            }
        }

        if (resto > 0) {
            letras += '';
        }

        return letras;
    } // Seccion()

    function Miles(num) {
        const divisor = 1000;
        const cientos = Math.floor(num / divisor);
        const resto = num - (cientos * divisor);

        const strMiles = Seccion(num, divisor, 'Mil', 'Mil');
        const strCentenas = Centenas(resto);

        if (strMiles === '') {
            return strCentenas;
        }

        return strMiles + ' ' + strCentenas;
    }
    // Miles()

    function Millones(num) {
        const divisor = 1000000;
        const cientos = Math.floor(num / divisor);
        const resto = num - (cientos * divisor);

        const strMillones = Seccion(num, divisor, 'Un Millon de', 'Millones de');
        const strMiles = Miles(resto);

        if (strMillones === '') {
            return strMiles;
        }

        return strMillones + ' ' + strMiles;
    }
    // Millones()

    return function NumeroALetras(num, currency) {
        currency = currency || {};
        const data = {
            numero: num,
            enteros: Math.floor(num),
            centavos: (((Math.round(num * 100)) - (Math.floor(num) * 100))),
            letrasCentavos: '',
            letrasMonedaPlural: currency.plural || 'Pesos', // 'PESOS', 'Dólares', 'Bolívares', 'etcs'
            letrasMonedaSingular: currency.singular || 'Peso', // 'PESO', 'Dólar', 'Bolivar', 'etc'
            letrasMonedaCentavoPlural: currency.centPlural || 'Centavos',
            letrasMonedaCentavoSingular: currency.centSingular || 'Centavo'
        };

        if (data.centavos > 0) {
            data.letrasCentavos = 'con ' + (function () {
                    if (data.centavos === 1) {
                        return Millones(data.centavos) + ' ' + data.letrasMonedaCentavoSingular;
                    } else {
                        return Millones(data.centavos) + ' ' + data.letrasMonedaCentavoPlural;
                    }
                })();
        }

        if (data.enteros === 0) {
            return 'Cero ' + data.letrasMonedaPlural + ' ' + data.letrasCentavos + ' 00/100';
        }

        if (data.enteros === 1) {
            return Millones(data.enteros) + ' ' + data.letrasMonedaSingular + ' ' + data.letrasCentavos;
        } else {
            return Millones(data.enteros) + ' ' + data.letrasMonedaPlural + ' ' + data.letrasCentavos;
        }
    };

  })();
  configRecibo: any;
  // tslint:disable-next-line:max-line-length
  constructor(public activeModal: NgbActiveModal, private prestamoService: PrestamosService, private configuracionService: ConfiguracionesService) {
      this.initConfigRecibo();
  }

  ngOnInit() {
    this.initReciboDetalle();
  }

  private initReciboDetalle() {
    this.prestamoService.obtenerDetalleRecibo(this.recibo.ID_RECIBO, this.recibo.ID_PRESTAMO).subscribe((res: any) => {
      Object.defineProperty(this.recibo, 'recibo_detalle', { value: res, enumerable: true });
    });
  }
  print(element) {
    let printContents, popupWin;
    printContents = document.getElementById(element).innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Imprimir Recibo</title>
          <style>
          hr {
            margin-top: 2px;
            margin-bottom: 2px;
            border: 1px dotted;
        }
        .table-borderless > tbody > tr > td,
        .table-borderless > tbody > tr > th,
        .table-borderless > thead > tr > td,
        .table-borderless > thead > tr > th {
            border: none;
        }
        .text-center {
            text-align: center;
        }
                  </style>
                  <link href="assets/vendor/bootstrap/css/bootstrap.min.css" rel="stylesheet">
        </head>
    <body onload="window.print();window.close()" style="width: 270px;">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }


  private initConfigRecibo() {
      this.configuracionService.obtenerConfiguraciones()
      .subscribe(res => this.configRecibo = res);
  }

}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/modals/detalle/detalle.component.ts